<template>
  <div class="main-body">
    <el-scrollbar class="customer-details-scroll">
      <div class="">
        <el-row :gutter="20">
          <el-col :xs="12" :sm="4" :md="4" :lg="3" style="margin-left: 10px">
            <el-input v-model="searchString" placeholder="Search" clearable=""></el-input>
          </el-col>
          <el-col :xs="12" :sm="4" :md="4" :lg="2">
            <el-button @click="searchData">Search</el-button>
          </el-col>
        </el-row>
      </div>
      <div class="" style="margin-top: 15px;">
        <el-table
          v-loading="customersLoading"
          class="table"
          :lazy="customersLoading"
          :data="customers"
          style="width: 100%; text-align: left; "
          @sort-change="sortChange">
          <el-table-column
            label="Id"
            prop="auto_id"
            sortable>
          </el-table-column>
          <el-table-column
            label="Name"
            prop="name">
            <template slot-scope="{ row }">
              <!-- <el-link :href="getCustomerUrl(row.auto_id)" >{{ row.name }}</el-link> -->
              {{ row.name }}
            </template>
          </el-table-column>
          <el-table-column
            label="Email"
            prop="email">
          </el-table-column>
          <el-table-column
            label="Phone"
            prop="phone">
          </el-table-column>
          <el-table-column
            label="User Type"
            prop="user_type">
          </el-table-column>
          <el-table-column
            label="Registered On"
            prop="created_at">
            <template slot-scope="{ row }">
              {{ dateFormat(row.created_at) }}
            </template>
          </el-table-column>
          <el-table-column
            label="Status"
            prop="status">
          </el-table-column>
          <el-table-column
            label="Referred By"
            prop="referred_by_id">
          </el-table-column>
          <el-table-column
            label="Email Verify"
            prop="email_verified">
            <template slot-scope="{ row }">
              {{ row.email_verified }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 20px; text-align: center;">
        <el-pagination
          @current-change="handlePageChange"
          @size-change="handlePageSizeChange"
          :current-page.sync="page"
          :page-sizes="[30, 40 ,50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCustomersCount">
        </el-pagination>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import { $adminAxios } from '../config/axios'
import priceMixin from '../mixins/priceMixin'
import moment from 'moment'

export default {
  name: 'Categories',
  mixins: [
    priceMixin,
  ],
  data: function () {
    return {
      defaultTableProps: {
        size: "mini",
        border: true,
      },
      columns: [{
        prop: 'title',
        label: 'Title',
        required: true,
      }],
      customers: [],
      totalCustomersCount: 0,
      customersLoading: true,
      page: 1,
      pageSize: 30,
      searchString: '',
      orderBy: 'title',
      orderType: 'asc',
    }
  },
  computed: {
    computedTableProps() {
      return {
        ...this.defaultTableProps,
        ...(this.tableProps || {}),
      };
    },
    dateFormat() {
      return (date) => {
        return moment.utc(date).format('MMM DD, yy hh:mm A')
      }
    }
  },
  mounted() {
    this.fetchCustomers()
  },
  methods: {
    getCustomerUrl(categorId) {
      return `/admin/customers/${categorId}`
    },
    async fetchCustomers (page, limit) {
      page = page || this.page
      limit = limit || this.pageSize

      this.customersLoading = true

      try {
        let queryParamsString = `page=${page}&limit=${limit}`

        if (this.searchString) {
          queryParamsString += `&search_string=${this.searchString}`
        }
        if (this.orderBy && this.orderType) {
          queryParamsString += `&order_type=${this.orderType}&order_by=${this.orderBy}`
        }

        const response = await $adminAxios.get(`/users?${queryParamsString}`)
        this.customers = response.data.data
        this.totalCustomersCount = response.data.total
      } catch (err) {
        console.error(err)
        this.$notify.success({
          title: 'Error',
          message: err.message || 'Something went wrong',
          type: 'error'
        });
      }

      this.customersLoading = false
    },
    getRowValue(object, columnObject) {
      const path = columnObject.prop;
      const type = columnObject.type;

      const value =
        typeof this.$lodash.result(object, path) === "undefined"
          ? "--"
          : this.$lodash.result(object, path);

      if (type === "date") {
        const valueTemp =
          value && value !== "--"
? {
              type: "string",
              value: moment.utc(new Date(value)).format('yyyy-mm-dd'),
            }
: { type: "string", value: "--" };
        return valueTemp;
      }
      if (Array.isArray(value)) {
        return { type: "array", value };
      }
      return { type: "string", value };
    },
    handlePageChange(page) {
      this.fetchCustomers(page, this.size)
    },
    handlePageSizeChange(size) {
      this.fetchCustomers(this.page, size)
    },
    createCustomer() {
      this.$router.push('/admin/customers/create')
    },
    searchData() {
      this.page = 1
      this.fetchCustomers()
    },
    sortChange(el) {
      this.orderBy = el.prop
      this.orderType = el.order === 'ascending' ? 'asc' : 'desc'
      this.page = 1
      this.fetchCustomers()
    },
  },
}
</script>

<style lang="scss" scoped>
.customer-details-scroll {
  position: relative;
  height: calc(100vh - 75px);
  margin-top: 10px;
}
</style>
